// const host = "http://localhost:8000/";
// const host = "https://propusk.belaz.minsk.by/";
// const host = "https://chb.by/";
// const host = "http://192.168.115.178:8001/";
const host = "https://chb.belaz.by/";
export default host;
